module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABXklEQVQ4T82Sv0sCYRjHn+c9xexOKVskvdM/oKW1wSVaChqC5n7QqFdYUxAIzUmdBg2RNQcNrdHi0NpSu76aNJRB3GmS9z5hJJx2R2vP+PD5vM/z8n0QPKqVj8dsYGOhLH90Q9Ct2TlSp7qMnQCA6hNiIbBZexjmfommkThApGUCuOrBCLBEhJeKXt12ygNiu6it2ATpDpmzE3rzvQe+GpFwAJVbCaEYTPOLvjwgmgWtDAj7SprfOF83i9ocEOwpGZ5yFa1CosLsz1Rwq8GdYvtwUhOSvyxnqkmviZyRPTOqP9WdYsuIxQVKd0qGa/9ArOXjwXEf4wzsaddVQbp/6wpNzdbbPzEBUCk5YpniGgie5SZfxRwI5x8pB8yKaOeAEJUVtohrlY/vOCxDXQfGTol6eXsXIhAIsSHrtTNP0DLUXYHop073OLzTePnz5PqAVUzM2wKiIb1aQgAaFr8ABRCaD6GujuEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alert.png
// module id = zZEU
// module chunks = 1